import { registerQuery } from 'data-fetching-client';
import { getInAppAddonsRpc } from 'growth-monetization-service-types';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
export const GET_ELIGIBLE_ADDONS = registerQuery({
  fieldName: 'eligibleAddOns',
  fetcher() {
    const client = createRpcClientV2({
      hubHttpClient: http
    });
    return client.call(getInAppAddonsRpc, {
      queryParameters: {}
    });
  }
});